import React, { useCallback, useEffect, useState, Fragment } from "react"
import { useDropzone } from "react-dropzone"
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from "@mui/material/Button";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

/**
 * array of existingFileDetailsArray is to display and download/delete exisitng file
 * 
 * existingFileDetailsArray={
 * fileName:'abc.doc',
 * fileSize:232333,
 * 
 * }
 *
 */

const MpgFileUpload = ({ name, label, rhfFormInstance, sx, required, disabled, multiple, persistantMsg, existingFileDetailsArray }) => {

    const myStyle = {}

    const [myFile, setMyFile] = useState([])
    useEffect(() => {
        setValue(name, myFile, { shouldValidate: true, })
    }, [myFile])

    const {
        register, unregister, setValue, watch,
        formState: { errors, isDirty, isSubmitting, touchedFields, submitCount },
    } = rhfFormInstance

    const onDrop = useCallback(
        (droppedFiles) => {
            setMyFile(droppedFiles)
            /**mannually triggering file validation after setValue/any change performed in the field */
            rhfFormInstance.trigger(name)
        },
        []
    )
    const { getRootProps, getInputProps, isDragActive, isDragAccept } = useDropzone({
        multiple: !!multiple || false,
        onDrop,
    })
    useEffect(() => {
        register(name)
        return () => {
            unregister(name)
        }
    }, [register, unregister, name])

    const removeFile = (fileToBeDeleted) => {
        // console.log("gl-remove is calling")
        const newList = myFile.filter((item) => {
            if (item.name !== fileToBeDeleted) {
                return item
            }
        })
        setMyFile(newList)
    }
    return (
        <FormControl
            error={!!errors && !!errors[name]}
            disabled={disabled}
            sx={[myStyle, sx]}
            required={required}
            fullWidth
        >
            <Typography sx={{ color: "#8991a0" }} variant="subtitle1" align="left">{label}</Typography>

            <Button
                {...getRootProps()}
                aria-label="delete"
                sx={{
                    backgroundColor: '#d6deff'
                }}
            >
                <CloudUploadIcon sx={{ margin: '5px' }} />
                <input
                    {...getInputProps()}
                    name={name}
                    id={`${name}-mpg-file upload`}
                />
                {
                    isDragActive ?
                        `Drop file here ...` :
                        `Drag & drop or Browse file`
                }
            </Button>
            { /**its a msg to be shown all time on screen for this field */}
            {
                !!persistantMsg ? (
                    <p style={{ margin: '0px' }}>{persistantMsg}</p>
                ) : ""
            }

            <FormHelperText>{!!errors && errors[name]?.message}</FormHelperText>

            {
                !!existingFileDetailsArray && existingFileDetailsArray.map((item, index) => {
                    const myfileSize = !!item.fileSize ? `(${item.fileSize / 1000} KB)` : '';
                    return (
                        <ListItem disablePadding key={`${item.name}-${index}`}>
                            <Grid>
                                <span style={{ color: '#0f3e8a' }}>{`${item?.fileName} ${myfileSize}`}</span>
                            </Grid>
                        </ListItem>
                    )
                })
            }

            { /**displaying just attached file */}
            {!!myFile?.length && (
                <List>
                    {
                        myFile.map((eachFile, index) => {
                            const myfileSize = !!eachFile.size ? `(${eachFile.size / 1000} KB)` : '';
                            return (
                                <ListItem disablePadding key={`${eachFile.name}-${index}`}>
                                    <Grid>
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => {
                                                removeFile(eachFile.name)
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>

                                        <span>{`${eachFile.name} ${myfileSize}`}</span>
                                    </Grid>

                                </ListItem>

                            )
                        })
                    }
                </List>
            )}
        </FormControl>
    )
}
export default MpgFileUpload